import { DateTime } from 'luxon'

export class FeedbackType {
	id: number
	key: string
	name: string
	titleTranslations: Record<string, string>
	isNegative: boolean
	shouldList: boolean
	active: boolean
	createdAt: DateTime
	updatedAt: DateTime

	constructor(data: {
		id: number
		key: string
		name: string
		titleTranslations: Record<string, string>
		isNegative: boolean
		shouldList: boolean
		active: boolean
		createdAt: DateTime
		updatedAt: DateTime
	}) {
		this.id = data.id
		this.key = data.key
		this.name = data.name
		this.titleTranslations = data.titleTranslations
		this.isNegative = data.isNegative
		this.shouldList = data.shouldList
		this.active = data.active
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
	}

	isNeutral(): boolean {
		return this.key === 'neutral'
	}

	isPositive(): boolean {
		return this.key === 'positive'
	}

	isNegativeDefault(): boolean {
		return this.key === 'negative'
	}

	static create(data: Partial<FeedbackType>): FeedbackType {
		const defaultData = {
			id: 0,
			key: '',
			name: '',
			titleTranslations: {},
			isNegative: false,
			shouldList: false,
			active: false,
			createdAt: DateTime.now(),
			updatedAt: DateTime.now(),
		}
		return new FeedbackType({
			...defaultData,
			...data,
		})
	}
}
